module.exports = __webpack_public_path__ + "static/media/feifengshan_package.5c8a6dbc.webp";